import { assertValidVersion } from "@tsparticles/engine";
import { EmojiDrawer } from "./EmojiDrawer.js";
export async function loadEmojiShape(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addShape(new EmojiDrawer(), refresh);
}
